import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sourceStreamSettingsNav';
export const useSourceStreamSettingsNavTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    sections: {
      main: 'Основные параметры',
    },
    va_group: 'Видеоаналитики',
    add_analytics: 'Добавить',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    sections: {
      main: 'Basic parameters',
    },
    va_group: 'Video analytics',
    add_analytics: 'Add',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    sections: {
      main: 'Parámetros básicos',
    },
    va_group: 'Videoanalíticas',
    add_analytics: 'Añadir',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    sections: {
      main: 'Parâmetros básicos',
    },
    va_group: 'Videoanalíticas',
    add_analytics: 'Adicionar',
  },
}) : {}) as Record<string, unknown>;
